var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.file,{tag:"component",staticClass:"AppIcon",class:_vm.className,style:(_vm.styleObj)})}
var staticRenderFns = []

export { render, staticRenderFns }